import { render, staticRenderFns } from "./RatiosTable.vue?vue&type=template&id=3854759a&"
import script from "./RatiosTable.vue?vue&type=script&lang=js&"
export * from "./RatiosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports